module.exports = __webpack_public_path__ + "static/media/shield-sign.47da9196.svg";